export class FormADMessage {

    constructor(){}

    public title= "form.formAD.title";
    public requis1= "form.formAD.requis1";
    public requis2=  "form.formAD.requis2";
    public infos=  "form.formAD.infos";
    public afficherlogo="form.formAD.afficherlogo";  
    public oui= "form.formAD.oui";
    public non= "form.formAD.non";
    public addlogo= "form.formAD.addlogo";
    public drag= "form.formAD.drag";
    public or= "form.formAD.or";
    public choisir= "form.formAD.choisir";
    public contenu= "form.formAD.contenu";

}